module.exports = __webpack_public_path__ + "static/media/restaurant-table.3af53ddb.jpg";